import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

interface RadioOption {
  value: string | boolean;
  label: string;
}

interface Props extends FieldProps<HTMLInputElement, FieldRenderProps<any>> {
  name: string;
  label?: ReactNode;
  options: RadioOption[];
  disabled?: boolean;
  disabledValues?: (string | boolean)[];
  order?: 'row' | 'column';
  bottomLabel?: boolean;
  onChangeValue?: (value: string | boolean) => void;
}

export const RadioField: FC<Props> = ({
  label,
  name,
  options,
  disabled = false,
  disabledValues,
  order = 'row',
  bottomLabel = false,
  onChangeValue,
  ...props
}) => {
  return (
    <Field name={name} {...props}>
      {({ input, meta }) => {
        const isValueEqual = (inputValue: any, optionValue: any) => {
          if (inputValue === optionValue) return true;
          if (inputValue === null || inputValue === undefined) return false;
          if (optionValue === null || optionValue === undefined) return false;
          return inputValue.toString() === optionValue.toString();
        };

        return (
          <div
            className={classNames('form-group', {
              'has-danger': (meta.error || meta.submitError) && meta.touched,
            })}
          >
            <div>
              {label && !bottomLabel && <label htmlFor={name}>{label}</label>}
              <div className={order}>
                {options.map((option, index) => (
                  <div
                    key={index}
                    className={classNames('padding0', {
                      'col-12 col-md': order === 'row',
                      'col-12': order !== 'row',
                    })}
                  >
                    <div className="form-check margin0">
                      <input
                        id={`${name}-${index}`}
                        name={name}
                        type="radio"
                        value={option.value?.toString()}
                        checked={isValueEqual(input.value, option.value)}
                        onChange={() => {
                          if (onChangeValue) {
                            onChangeValue(option.value);
                          } else {
                            input.onChange(option.value);
                          }
                        }}
                        disabled={disabled || !!disabledValues?.includes(option.value)}
                      />
                      <label htmlFor={`${name}-${index}`} className="inkBlue">
                        {option.label}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
              {label && bottomLabel && <label htmlFor={name}>{label}</label>}
              {(meta.error || meta.submitError) && meta.touched && (
                <label htmlFor={name} className="error">
                  {meta.error || meta.submitError}
                </label>
              )}
            </div>
          </div>
        );
      }}
    </Field>
  );
};
